// Wait for x ms .then(() => yourfunction())
const wait = async (milliseconds) => new Promise((resolve) => setTimeout(resolve, milliseconds));

export default wait;

// How to use:
// wait(1000).then(() => doSomething());
